// The single cross-surface Unleash stickiness anchor. Shared verbatim with
// aha-pricing (which mints the same-named cookie on the pricing page) so one
// human resolves to one variant on every surface. Format: uuid v4, dashes kept.
//
// Kept in a dependency-free module so BOTH readers (unleashSession.js's
// readRawSessionCookie and unleash.js's readSessionCookie) import the name from
// ONE source of truth without dragging the cookie service / Vuex store into the
// light-weight unleash.js bootstrap import graph.
export const UNLEASH_SESSION_COOKIE = 'aha_unleash_session'
